import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  isFulfilledAction,
  isPendingAction,
  isRejectedAction
} from './actions';

const name = 'localizations';

export const getLocales = createAsyncThunk(
  `${name}/getLocales`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/localizations');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getLocalizations = createAsyncThunk(
  `${name}/getLocalizations`,
  async (lang, { rejectWithValue }) => {
    try {
      const locale = lang || localStorage.getItem('lang') || 'fi';
      const response = await axios.get(`/api/localizations/${locale}`);
      return {
        locale,
        localizations: response.data
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const localizationSlice = createSlice({
  name,
  initialState: {
    loading: false,
    errors: false,
    locale: null,
    defaultLang: window._env.defaultLang || 'fi',
    options: ['fi'],
    sortedOptions: [],
    messages: null,
    edit: {
      enabled: false,
      uuid: null,
      id: null
    }
  },
  reducers: {
    setEditMode: (state, action) => {
      state.edit = {
        enabled: Boolean(action.payload),
        uuid: null,
        id: null
      };
    },
    setEditMessage: (state, action) => {
      const { id, uuid } = action.payload || {};

      state.edit.id = id || null;
      state.edit.uuid = uuid || null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocales.fulfilled, (state, action) => {
        state.options = action.payload;
        state.sortedOptions = [...state.options].sort((a, b) => {
          if (a === state.defaultLang) return -1;
          if (b === state.defaultLang) return 1;
          return a.localeCompare(b);
        });
      })
      .addCase(getLocalizations.fulfilled, (state, action) => {
        const { locale, localizations } = action.payload;
        localStorage.setItem('lang', locale);
        state.locale = locale;
        state.messages = localizations;
      })     
      .addMatcher(isPendingAction(name), (state) => {
        state.loading = true;
        state.errors = false;
      })
      .addMatcher(isRejectedAction(name), (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addMatcher(isFulfilledAction(name), (state) => {
        state.loading = false;
      });
  }
});

export const { setEditMode, setEditMessage } = localizationSlice.actions;
export default localizationSlice.reducer;
